import React from 'react'
import Navbar from '../components/Navbar'
import AlmondsComponent from '../components/Almonds'
import Footer from '../components/Footer'
import Scroll from '../components/Utils'

const Almonds = () => {
    return (
        <>
            <Scroll />
            <Navbar />
            <AlmondsComponent />
            <Footer />
        </>
    )
}

export default Almonds